import { CharacterType, ICharacter } from "@next-platform/client-common-core";

export const getProfilePathForCharacter = (character: ICharacter): string => {
  const characterId = character.id || character.character_id;
  if (character.type === CharacterType.META) {
    return `/group/${characterId}`;
  } else {
    return `/chatbot/${characterId}`;
  }
};
